module.exports = __webpack_public_path__ + "json/version.json";


/*****************
 ** WEBPACK FOOTER
 ** ./moveToDist/json/version.json
 ** module id = 357
 ** module chunks = 0
 **/